import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Injectable()
export class AuthGuard implements CanActivate {
  private userPermissions: Map<string, Set<string>> = new Map<string, Set<string>>();
  permissionMap: any;
  constructor( private translateService: TranslateService,private jwtHelper: JwtHelperService, private router: Router, private http: HttpClient) {
 try {
    this.permissionMap = JSON.parse(window.localStorage.getItem('userPermissionCheck'));
    if (this.permissionMap) {
      const permissionnew = this.permissionMap.map(item => {
        const operationRouteArray = item.operation_route.split(",");
        this.userPermissions.set(item.moduleaccess_module.module_route, new Set<string>(operationRouteArray));
      })
      // console.log("this.userPermissions 2", this.userPermissions);
    }
     } catch (e) {
      this.redirectToLoginWithError();
    }

  }

    private redirectToLoginWithError(): void {
    window.localStorage.clear();
    this.translateService.get('app').subscribe((translate) => {
      Swal.fire({
        icon: 'error',
        title: translate.oops,
        text: translate.session_expired,
      });
      this.router.navigate(['/auth/login']);
    });
  }

  // tslint:disable-next-line:typedef
  async canActivate(next: ActivatedRouteSnapshot) {
    const requiredPermissions = next.data.requiredPermissions as string[];
    const moduleId = next.data.moduleId as number;
    // console.log("requiredPermissions", requiredPermissions)
    // console.log("moduleId", moduleId)
    const token = localStorage.getItem('accessToken');
    let isTokenValid = false;
    try {
      isTokenValid = !!token && !this.jwtHelper.isTokenExpired(token);
    } catch (e) {
      isTokenValid = false;
    }

    if (isTokenValid) {
      // console.log(this.jwtHelper.decodeToken(token));
      if (requiredPermissions[0] != "no") {
        if (this.hasPermissions(moduleId, requiredPermissions)) {
          return true;
        } else {

          // console.log("Access Denied")
         return this.router.createUrlTree(['/auth/access-denied']);


        }
      } else {
        return true;
      }

    } else {
      if (token) {
        localStorage.removeItem('accessToken');
      }
      this.router.navigate(['/auth/login']);
    }
  }

  private hasPermissions(moduleId: number, requiredPermissions: string[]): boolean {
    // console.log("moduleId, requiredPermissions")
    const userModulePermissions = this.userPermissions.get(moduleId[0]);
    // console.log("userModulePermissions")
    if (!userModulePermissions) {
      return false; // Module not found in user's permissions
    }
    return requiredPermissions.every(permission => userModulePermissions.has(permission));
  }

}
